(ns ui.view.entity-graph.auto-layout
  (:require [ui.view.entity-graph.model :as m]
            [re-frame.core :as rf]
            ["@dagrejs/dagre" :as dagre]))

(defonce dagre-graph
  (atom nil))

(defn new-dagre-graph
  []
  (let [dg (-> dagre
               .-graphlib
               .-Graph
               new)]
    ^js (.setDefaultEdgeLabel dg (fn [] {}))
    dg))

(defn reset-graph!
  [g]
  (doseq [{:strs [v w]} (js->clj (.edges g))]
    ^js (.removeEdge g v w))
  (doseq [n (.nodes g)]
    ^js (.removeNode g n))
  nil)

(defn dagre-layout
  [{:keys [map-profiles connectors direction positions] :as _ctx}]
  (let [direction (or direction :vertical)
        dagre-dir (if (= direction :horizontal)
                    "LR"
                    "TB")
        map-profile-ids (->> map-profiles
                             (mapv :db/id))
        mp-positions (->> (select-keys positions map-profile-ids)
                          vals)
        xs (->> mp-positions
                (mapv :x)
                (filterv number?)
                (filterv #(not (js/isNaN %))))
        ys (->> mp-positions
                (mapv :y)
                (filterv number?)
                (filterv #(not (js/isNaN %))))
        min-x (if (seq xs)
                (apply min xs)
                0.0)
        min-y (if (seq ys)
                (apply min ys)
                0.0)
        _ (reset-graph! @dagre-graph)
        _ ^js (.setGraph @dagre-graph #js {:rankdir dagre-dir})
        _ (doseq [{:keys [db/id]} map-profiles]
            (let [wh #js {:width m/WIDTH
                          :height m/HEIGHT}]
              ^js (.setNode @dagre-graph (str id) wh)))
        _ (doseq [{:graph-reference/keys [source target]} connectors]
            ^js (.setEdge @dagre-graph (str source) (str target)))
        _ (.layout dagre @dagre-graph)]
    (->> map-profiles
         (reduce (fn [m {:keys [db/id]}]
                   (if-let [layout-node (.node @dagre-graph (str id))]
                     (let [layout-x (.-x layout-node)
                           layout-y (.-y layout-node)
                           ;;translate based on the leftmost & topmost nodes:
                           t-x (+ layout-x min-x)
                           t-y (+ layout-y min-y)

                           x (- t-x (/ m/WIDTH 2))
                           y (- t-y (/ m/HEIGHT 2))
                           position {:x x :y y}]
                       (assoc! m id position))
                     (assoc m id {:x 0 :y 0})))
                 (transient {}))
         persistent!)))

(defn auto-layout-to-view-config!
  [ctx]
  (let [map-profiles @(rf/subscribe [m/visible-map-profiles ctx])
        connectors @(rf/subscribe [m/visible-connectors ctx])
        ;;TODO only if loaded(?) - do we also need to watch m/loaded?
        positions (when @dagre-graph
                    (dagre-layout (assoc ctx
                                         :map-profiles map-profiles
                                         :connectors connectors)))]
    (when (seq positions)
      (rf/dispatch
       [m/node-changes ctx {:auto-layout? true
                            :view-config {:positions positions}}]))))

(defn remove-auto-layout-watcher!
  [ctx]
  (remove-watch (rf/subscribe [m/visible-nodes-edges-ids ctx])
                :auto-layout))

(defn auto-layout-watch!
  [ctx]
  (let [ready? @(rf/subscribe [m/ready? ctx])
        manual-positions? @(rf/subscribe [m/manual-positions? ctx])]
    (when ready?
      (if manual-positions?
        (remove-auto-layout-watcher! ctx)
        (js/setTimeout
         (partial auto-layout-to-view-config! ctx)
         20)))))

;;TODO subscribe shouldn't be used outside reactive context
;; => new approach might be needed
(defn add-auto-layout-watcher!
  [ctx]
  (let [visible (rf/subscribe [m/visible-nodes-edges-ids ctx])]
    (js/setTimeout
     (fn []
       (add-watch visible :auto-layout
                  (fn [_key _atom _old-state _new-state]
                    (auto-layout-watch! ctx))))
     100)))

(defn init
  [_ctx]
  (reset! dagre-graph (new-dagre-graph)))
